import React, { useContext } from "react";
import { useTranslation } from 'react-i18next';

import Button from "../../uiComponents/Button";
import { ModalContext } from "../../ModalContext";
import { useDispatch } from "react-redux";
import { signOut } from "../../../store/actions/user";

const LogoutModal = ({
  closeModal,
}) => {
  const { t } = useTranslation();

  const { handleModal } = useContext(ModalContext);
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(signOut());
    handleModal();
  };

  return (
    <div className="modal_container">
      <p className="modal_title">{t('are_you_sure_want_logout')}</p>
      <div className="modal_btns">
        <Button
          transparent={true}
          clickFunction={closeModal}
        >
          {t('cancel')}
        </Button>

        <Button
          clickFunction={handleClick}
        >
          {t('logout')}
        </Button>
      </div>
    </div>
  );
};

export default LogoutModal;
